import { Instance, SnapshotOut, types } from 'mobx-state-tree';

/**
 * # UserDeptRole
 *
 * 사용자 다중 부서 역할 (겸직) 모델 (TB_USER_DEPT_ROLE)
 */
export const UserDeptRole = types
  .model('UserDeptRole')
  // --------------------------------------------------------------------------
  .props({
    userDeptRoleSid: types.optional(types.number, 0),
    userSid: types.optional(types.number, 0),
    deptSid: types.optional(types.number, 0),
    roleTypeCd: types.optional(types.number, 302103), // 기본값: MEMBER (소속원)
    isPrimary: types.optional(types.boolean, false),
    startDt: types.maybeNull(types.union(types.string, types.number)),
    endDt: types.maybeNull(types.union(types.string, types.number)),
    deptNm: types.optional(types.string, ''),
    userNm: types.maybeNull(types.optional(types.string, '')),
  })
  // --------------------------------------------------------------------------
  // MUTATEs ONLY! - 모델 상태를 변경
  // REQUESTs는 스토어 모델에 작성하세요.
  .actions((self) => ({
    setProps: (props: { [key: string]: any }) => {
      const newProps = { ...self, ...props } as IUserDeptRole;
      (Object.keys(newProps) as TUserDeptRoleKeys[]).forEach((key) => {
        // @ts-ignore
        self[key] = newProps[key];
      });
    },
  }));

// --------------------------------------------------------------------------
type TUserDeptRole = Instance<typeof UserDeptRole>;
type TUserDeptRoleSnapshot = SnapshotOut<typeof UserDeptRole>;

export interface IUserDeptRole extends TUserDeptRole {}
export type TUserDeptRoleKeys = keyof TUserDeptRoleSnapshot & string;
export interface IUserDeptRoleSnapshot extends TUserDeptRoleSnapshot {}
export const createUserDeptRole = () => types.optional(UserDeptRole, {} as TUserDeptRole);
